<ng-container *transloco="let t">
  @if (isVisible()) {
    <ld-base-modal [title]="t('commonLabelsCongratulations')" [showCloseButton]="true" (closeModal)="onDismiss()">
      <div modal-content>
        <div class="flex flex-col items-center gap-6">
          <ld-svg-icon [src]="approvedBadgeIcon" class="w-[74px] h-[74px]" aria-hidden="true" />

          <p class="font-dm text-ld-neutral-500 leading-relaxed text-center">
            {{ t('modalsHelocEligibilityDescription') }}
          </p>
        </div>
      </div>
      <div modal-footer class="flex justify-end gap-3">
        <button type="button" class="btn-outline-ld-purple" (click)="onRemindLater()">
          {{ t('commonButtonsRemindLater') }}
        </button>
        <button type="button" class="btn-primary-ld-purple" (click)="onContinue()">
          {{ t('commonButtonsContinue') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
